<template>
  <streaming-content
    :narrative="narrative"
    :debug-mode="debugMode"
    :fullScreen='true'
  ></streaming-content>
</template>

<script>
// import Component from "../component_location"
// import Watch from "@/views/Narratives/Watch.vue";
import Stream from "@/views/Narratives/Stream.vue";
import StreamingContent from "@/views/Narratives/StreamingContent";

export default {
  components: { StreamingContent },

  props: { username: { type: String }, narrativeName: { type: String } },

  data() {
    return {
      debugMode: false,
    };
  },

  watch: {},

  methods: {},

  computed: {
    narrative() {
      return this.$store.state.narratives.current;
    },
  },

  mounted() {
    let details = {
      username: this.username,
      narrativeName: this.narrativeName,
    };
    this.$store.dispatch("narratives/getNarrative", details);
  },
};
</script>

<style></style>
